import { useAppConfig } from "@/appConfig";

export const useCurrentWebsite = () => {
  const { tenant } = useAppConfig();
  const isGitchaDefaultWebsite = tenant?.id === "default";
  return { isGitchaDefaultWebsite, mls: tenant?.id };
}